import React, { useState } from "react";
const ReactViewer = require("react-viewer");

const Viewer = props => {
  const [displayViewer, setDisplayViewer] = useState(false);
  return (
    <div>
      <img
        style={{cursor:"zoom-in", ...props.style}}
        onClick={() => {
          setDisplayViewer(true);
        }}
        src={props.url}
        alt={"Proposition de photo"}
      />
      <ReactViewer
        visible={displayViewer}
        drag={true}
        noClose={false}
        rotatable={true}
        scalable={true}
        downloadable={false}
        onMaskClick={() => {
          setDisplayViewer(false);
        }}
        onClose={() => {
          setDisplayViewer(false);
        }}
        images={[
          {
            src: props.url,
            alt: "",
            downloadUrl: props.url
          }
        ]}
      />
    </div>
  );
};

export default Viewer;



// WEBPACK FOOTER //
// src/components/photo/Viewer.js